<template>
  <div class="lp-view">
    <section class="start-section">
      <div class="box">
        <div>
          <h1 class="main-text text-orange" v-html="$t('view.component.topup.auto.lp.startSection.header1')"></h1>
          <h2 class="main-title text-white" v-html="$t('view.component.topup.auto.lp.startSection.header2')"></h2>
          <p class="text-white" v-html="$t('view.component.topup.auto.lp.startSection.text1')"></p>
        </div>
      </div>
      <div class="box image-box"></div>
    </section>

    <section class="how-section">
      <div class="box">
        <div>
          <h2 class="main-title" v-html="$t('view.component.topup.auto.lp.howSection.header1')"></h2>
        </div>
      </div>
      <div class="box">
        <div>
          <p v-html="$t('view.component.topup.auto.lp.howSection.text1')"></p>
          <p v-html="$t('view.component.topup.auto.lp.howSection.text2')"></p>
        </div>
      </div>
    </section>

    <section class="video">
      <privacy-iframe width="560" height="315"
              src="https://www.youtube.com/embed/Xnn_5piAJ-k?si=RpeK5yaIRT2ysfCt"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
      </privacy-iframe>
    </section>

    <section class="media-section">
      <div>
        <div class="box">
          <div>
            <h2 class="main-title text-white" v-html="$t('view.component.topup.auto.lp.mediaSection.header1')"></h2>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/Xnn_5piAJ-k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
          </div>
        </div>
        <div class="box">
          <div>
            <ol class="text-white">
              <li v-html="$t('view.component.topup.auto.lp.mediaSection.list1')"></li>
              <li>{{ $t('view.component.topup.auto.lp.mediaSection.list2') }}
                <ul>
                  <li v-html="$t('view.component.topup.auto.lp.mediaSection.list21')"></li>
                  <li v-html="$t('view.component.topup.auto.lp.mediaSection.list22')"></li>
                  <li v-html="$t('view.component.topup.auto.lp.mediaSection.list23')"></li>
                </ul>
              </li>
              <li v-html="$t('view.component.topup.auto.lp.mediaSection.list3')"></li>
            </ol>
          </div>
        </div>
      </div>
      <div>
        <router-link :to="loginLink" v-if="!isUserLogged" class="primary on-dark">
          {{ $t('view.component.topup.auto.lp.buttonNotLogged') }}
        </router-link>
        <router-link :to="autoTopupLink" v-if="isUserLogged" class="primary on-dark">
          {{ $t('view.component.topup.auto.lp.buttonLogged') }}
        </router-link>
      </div>
    </section>

    <section class="secure-section">
      <div class="box">
        <div>
          <h2 class="main-title" v-html="$t('view.component.topup.auto.lp.secureSection.header1')"></h2>
          <p v-html="$t('view.component.topup.auto.lp.secureSection.text1')"></p>
          <ul>
            <li v-html="$t('view.component.topup.auto.lp.secureSection.list1')"></li>
            <li v-html="$t('view.component.topup.auto.lp.secureSection.list2')"></li>
            <li v-html="$t('view.component.topup.auto.lp.secureSection.list3')"></li>
            <li v-html="$t('view.component.topup.auto.lp.secureSection.list4')"></li>
          </ul>
        </div>
      </div>
      <div class="box">
        <div>
          <router-link :to="loginLink" v-if="!isUserLogged" class="primary">
            {{ $t('view.component.topup.auto.lp.buttonNotLogged') }}
          </router-link>
          <router-link :to="autoTopupLink" v-if="isUserLogged" class="primary">
            {{ $t('view.component.topup.auto.lp.buttonLogged') }}
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ROUTING } from '@/orange/const/routing.const'
import { mapGetters } from 'vuex'
export default {
  name: 'TopupAutoLpView',
  computed: {
    ...mapGetters({
      isUserLogged: 'isUserLogged'
    })
  },
  data () {
    return {
      loginLink: ROUTING.user.login,
      autoTopupLink: ROUTING.topup.auto.step1
    }
  }
}
</script>

<style lang="scss" src="../../../assets/scss/components/_lp.scss"></style>
<style lang="scss" src="../../../assets/scss/elems/_buttons.scss"></style>
